<template lang="pug">
//- ok: text textarea, select, multi-select, date, time,
 textGP
v-form(ref="formEl")
  v-row
    v-col(cols="2")
      v-subheader {{title}}
    v-col(cols="10")
      v-text-field(v-if="['text','date','time'].includes(type)"
        outlined
        v-model="value" 
        :type="type"
        :rules="ruleList"
        ref="inputEl"
        :hint="description"
        persistent-hint
      )
      v-textarea(v-else-if="type==='textarea'"
        outlined
        v-model="value"
        :type="type"
        :rules="ruleList"
        ref="inputEl"
        :hint="description"
        persistent-hint
      )
      v-checkbox(v-else-if="type==='switch'"
        outlined
        v-model="value"
        :rules="ruleList"
        ref="inputEl"
        :hint="description"
        persistent-hint
      )
      v-select(v-else-if="type.includes('select')"
        outlined
        v-model="value"
        :rules="ruleList"
        ref="inputEl"
        :hint="description"
        persistent-hint
        :items="selValue"
        :multiple="type === 'multi-select'"
      )
      inputTextGP(v-else-if="type==='textGP'"
        ref="inputEl"
        @update-value="updateTextGPValue"
        :title="title"
        :description="description"
        :type="type"
        :rules="rules"
      )
</template>

<script>
import inputTextGP from './InputTextGP'
export default {
  components: { inputTextGP },
  props: {
    description: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: []
    },
    selValue: {
      type: Array,
      default: []
    },
    title: {
       type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: null
    }
  },
  methods: {
    validate(){
      if (['textGP', 'school'].includes(this.type)) {
        return this.$refs.inputEl.validate()
      }
      return this.$refs.formEl.validate()
    },
    updateTextGPValue(nv) {
      this.value = nv
    }
  },
  computed: {
    ruleList(){
      if(this.rules.length === 0) return []
      return this.rules.map(e =>{
        if (e === 'required') return e => !!e || `${this.title}為必填欄位` 
        if (e === 'number') return e => !isNaN(+e) || `${this.title}必須是數字` 
        if (e === 'email') return e => /.+@.+/.test(e) || `${this.title}格式有誤`
        if (e === 'id') return e => /^[A-Z]{1}[1-2]{1}[0-9]{8}$/.test(e) || `${this.title}格式有誤`
        if (e === 'agreement') return e => !!e || '請勾選授權同意, 如有疑問請聯繫主辦單位'
        return true
      })
    }

  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/views/ApplicationForm/MyInput.vue